export enum DiscountType {
  CLAIM = 'Claim',
  //ADJUSTMENT = 'Adjustment Rebate',
  // FIXED = 'Fixed Rebate',
}
